<template>
  <div class="loading-overlay" role="status" aria-live="polite">
    <div class="loading-content">
      <img class="logo" src="@/images/coloredfinallogochanged.png" alt="Barbershop Talk loading" width="100" height="100">
      <div class="tagline-wrapper">
        <p class="loading-tagline">The Conversation Starts Here</p>
        <span class="tagline-bar"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingOverlay"
};
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0; right: 0; bottom: 0; left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(160deg, #1a8de0 0%, #2a9cff 60%, #178aef 100%);
  z-index: 10000;
  animation: fadeIn 0.3s ease;
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 28px;
}

.logo {
  width: 100px;
  height: 100px;
  background-color: #fff;
  border-radius: 50%;
  padding: 20px;
  animation: pulse 1.5s ease-in-out infinite;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
}

.tagline-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  animation: riseIn 0.7s ease 0.2s both;
}

.loading-tagline {
  color: rgba(255, 255, 255, 0.95);
  font-family: 'Titillium Web', sans-serif;
  font-size: 1.1rem;
  font-weight: 300;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  margin: 0;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}

.tagline-bar {
  display: block;
  width: 40px;
  height: 2px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 2px;
}

@keyframes pulse {
  0%, 100% { transform: scale(1);   opacity: 1;   }
  50%       { transform: scale(1.1); opacity: 0.85; }
}

@keyframes riseIn {
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0);    }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}
</style>
